const UserAddSvg = ({
  width = 21,
  height = 17,
  viewBox = '0 0 21 17',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M13 16C13 13.7909 10.3137 12 7 12C3.68629 12 1 13.7909 1 16M17 13V10M17 10V7M17 10H14M17 10H20M7 9C4.79086 9 3 7.20914 3 5C3 2.79086 4.79086 1 7 1C9.20914 1 11 2.79086 11 5C11 7.20914 9.20914 9 7 9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default UserAddSvg;
